import { memo } from 'react';
import { Center } from '@chakra-ui/react';

import NextImage from 'shared/NextImage';

import { DEFAULT_BORDER } from 'constants/global';
import RightAngle from 'assets/icons/RightAngle.svg';
import DownAngle from 'assets/icons/DownAngle.svg';
import LeftAngle from 'assets/icons/LeftAngle.svg';
import UpAngle from 'assets/icons/UpAngle.svg';
import Cross from 'assets/icons/Cross.svg';

const arrowsIcon = {
  right: RightAngle,
  down: DownAngle,
  up: UpAngle,
  left: LeftAngle,
  cross: Cross,
};

const IconButton = ({
  direction = 'right',
  icon = null,
  iconProps = null,
  disableHover = false,
  ...props
}) => {
  const iconDirection = arrowsIcon[direction];

  return (
    <Center
      boxSize={{ laptop: '64px', tablet: '40px', mobile: '48px' }}
      boxSizing="border-box"
      border={DEFAULT_BORDER}
      borderColor="dark"
      borderRadius="50%"
      cursor={disableHover ? 'default' : 'pointer'}
      role="group"
      p="0"
      pos="relative"
      zIndex="2"
      transition="background-color .2s, filter .2s, transform .2s"
      _hover={disableHover ? null : { bgColor: 'bg.black' }}
      {...props}
    >
      <NextImage
        _groupHover={
          !disableHover && {
            filter: 'brightness(0) invert(1)',
          }
        }
        w={{ laptop: '24px', mobile: '16px' }}
        h={{ laptop: '24px', mobile: '16px' }}
        src={icon ? icon : iconDirection}
        alt="arrow_icon"
        userSelect="none"
        {...iconProps}
      />
    </Center>
  );
};

export default memo(IconButton);
